var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav',[_c('h1',{staticStyle:{"cursor":"pointer"},on:{"click":() => {
          _vm.$route.name !== 'home' ? _vm.navigate() : void 0;
        }}},[_vm._v(" Taylor Swift Lyrics Quiz ")])]),(_vm.fetched)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }